<!-- Large viewport -->
<div class="recover-username-container mat-typography large-viewport">
  <mat-card class="recover-username-card">
    <h2 class="recover-username-title">Recover Username</h2>

    <p class="recover-username-desc">Enter your email, last 4 digits of SSN, and date of birth</p>

    @if (errorMessage.length > 0) {
      <p class="error-message">{{ errorMessage }}</p>
    }

    @if (successMessage.length > 0) {
      <p class="success-message">{{ successMessage }}</p>
    }

    <form class="recover-username-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" required />
          <mat-error>
            @if (form.get('email')?.hasError('required')) { Email is required. }
            @if (form.get('email')?.hasError('email')) { Please enter a valid email address. }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Last 4 digits of SSN</mat-label>
          <input matInput type="text" maxlength="4" formControlName="ssnLast4" required />
          <mat-error>
            @if (form.get('ssnLast4')?.hasError('required')) { Last 4 digits of SSN are required. }
            @if (form.get('ssnLast4')?.hasError('pattern')) { Please enter exactly 4 digits. }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Date of Birth</mat-label>
          <input matInput type="date" formControlName="dateOfBirth" required />
          <mat-error>
            @if (form.get('dateOfBirth')?.hasError('required')) { Date of Birth is required. }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="action-buttons">
        <button type="button" mat-button class="back-button" (click)="goBack()">Back</button>
        <button type="submit" mat-raised-button [disabled]="isSubmitting || !form.valid">Submit</button>
      </div>
    </form>
  </mat-card>
</div>

<!-- Small viewport -->
<div class="recover-username-container mat-typography small-viewport">
  <h2>Recover Username</h2>
  <p>Enter your email, last 4 digits of SSN, and date of birth</p>

  @if (errorMessage.length > 0) {
    <p class="error-message">{{ errorMessage }}</p>
  }
  @if (successMessage.length > 0) {
    <p class="success-message">{{ successMessage }}</p>
  }

  <form class="recover-username-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-field">
      <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" required />
        <mat-error>
          @if (form.get('email')?.hasError('required')) { Email is required. }
          @if (form.get('email')?.hasError('email')) { Please enter a valid email address. }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
        <mat-label>Last 4 digits of SSN</mat-label>
        <input matInput type="text" maxlength="4" formControlName="ssnLast4" required />
        <mat-error>
          @if (form.get('ssnLast4')?.hasError('required')) { Last 4 digits of SSN are required. }
          @if (form.get('ssnLast4')?.hasError('pattern')) { Please enter exactly 4 digits. }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
        <mat-label>Date of Birth</mat-label>
        <input matInput type="date" formControlName="dateOfBirth" required />
        <mat-error>
          @if (form.get('dateOfBirth')?.hasError('required')) { Date of Birth is required. }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="action-buttons">
      <button type="button" mat-button class="back-button" (click)="goBack()">Back</button>
      <button type="submit" mat-raised-button [disabled]="isSubmitting || !form.valid">Submit</button>
    </div>
  </form>
</div>
